import { useEffect, useRef } from 'react';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Player, PlayerEvent } from '@lottiefiles/react-lottie-player';
import * as confetti from 'assets/js/animations/confetti-sides.json';
import { motion } from 'framer-motion';

interface RecommendedActionCompletionAnimationProps {
    onComplete: () => void;
}
const RecommendedActionCompletionAnimation = ({
    onComplete,
}: RecommendedActionCompletionAnimationProps) => {
    const completeTimeout = useRef<NodeJS.Timeout>();

    useEffect(() => {
        return () => {
            clearTimeout(completeTimeout.current);
        };
    }, []);

    return (
        <div className="absolute left-0 top-0 flex h-full w-full items-center justify-center">
            <motion.div
                className="absolute h-full w-full"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
            >
                <div className="absolute h-full w-full bg-[#ECFDF3]" />
            </motion.div>
            <Player
                autoplay
                rendererSettings={{ preserveAspectRatio: 'xMidYMin slice' }}
                src={JSON.stringify(confetti)}
                className={`pointer-events-none absolute left-0 top-0 h-full w-full`}
                onEvent={event => {
                    if (event === PlayerEvent.Play) {
                        completeTimeout.current = setTimeout(onComplete, 4000);
                    }
                }}
            />
            <motion.svg
                className="absolute size-14 rounded-full bg-white"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{
                    type: 'spring',
                    visualDuration: 0.5,
                    bounce: 0.6,
                    delay: 0.25,
                }}
            >
                <FontAwesomeIcon icon={faCircleCheck} className="absolute text-[#12B76A]" />
            </motion.svg>
        </div>
    );
};

export { RecommendedActionCompletionAnimation };
